// PARA-106 §4 / PARA-112 — тонкая обёртка над общим api-client (shared/api-client).
// Отдельный ключ sessionStorage от frontend/ (AC-E1/AC-E2 — admin-токен не
// смешивается с access_token OWNER). onUnauthorized регистрируется лениво
// AdminAuthProvider (useEffect), поэтому в фабрику передаём стабильную косвенность.
import { createApiClient, ApiError, type ApiRequestOptions } from '@shared/api-client';

let unauthorizedHandler: (() => void) | null = null;

export function registerUnauthorizedHandler(handler: () => void): void {
  unauthorizedHandler = handler;
}

const client = createApiClient({
  storageKey: 'admin_access_token',
  onUnauthorized: () => unauthorizedHandler?.(),
});

export const apiRequest = client.apiRequest;
export const adminAccessTokenStorage = client.tokenStorage;
export { ApiError };
export type { ApiRequestOptions };
